module.exports = __webpack_public_path__ + "img/tag_xj@2x.28f7aac7.svg";